<template>
    <div class="alerts">
        <div v-for="(alert, key) in alerts" class="alert" :class="getClass(alert.type)" v-text="alert.content" :key="key">
            <span></span>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "Alerts",
        computed: {
            ...mapGetters('app', {
                alerts: 'getAlerts',
            })
        },
        methods: {
            getClass(type) {
                switch (type) {
                    case 'success':
                        return 'alert-success';
                    case 'warning':
                        return 'alert-warning';
                    case 'error':
                        return 'alert-danger';
                    case 'info':
                        return 'alert-info';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .alerts {
        position: fixed;
        top: 15px;
        right: 30px;
        z-index: 10000;

        & > * {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px !important;
            animation: fade-in 200ms;
            font-size: small;
        }
    }

    @keyframes fade-in {
        from {
            opacity: 0;
            transform: translateY(25%);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>